import { createSlice } from '@reduxjs/toolkit'
import { INomineeDetails, IProposerDetailsFD, QuotationsDetialsFD } from 'types'

export interface IStateGroupFD {
  suitabilityFormDetailsFD: IProposerDetailsFD
  quotationDetailsFD: QuotationsDetialsFD
  nomineeDetailsFD: INomineeDetails
}
const initialState: IStateGroupFD = {
  suitabilityFormDetailsFD: {
    occupation: '',
    address: '',
    address_two: '',
    pincode: null,
    city: '',
    state: '',
    phone: '',
    email: '',
    fd_maturity_amt: null,
    fd_start_date: '',
    fd_end_date: '',
    fd_acct_no: '',
    quote_id: '',
    consent_id: '',
  },
  quotationDetailsFD: {
    name: '',
    code: '',
    logo: '',
    suminsured: '',
    premiumamount: '',
  },
  nomineeDetailsFD: {
    nomineeSalutation: '',
    nomineeFirstName: '',
    nomineeLastName: '',
    dob: '',
    nomineeGender: '',
    relationship: '',
    nomineeEmail: '',
    nomineePhoneNumber: '',
  },
}

const groupFDSlice = createSlice({
  name: 'groupFDSlice',
  initialState: initialState,
  reducers: {
    updateSuitabilityFormDetails: (state, action) => {
      state.suitabilityFormDetailsFD = action.payload
    },
    updateQuotationDetails: (state, action) => {
      state.quotationDetailsFD = action.payload
    },
    updateQuoteID: (state, action) => {
      state.suitabilityFormDetailsFD.quote_id = action.payload
    },
    updateConsentID: (state, action) => {
      state.suitabilityFormDetailsFD.consent_id = action.payload
    },
    updateNomineeDetails: (state, action) => {
      state.nomineeDetailsFD = action.payload
    },

    updateGroupFDData: (state, action) => {
      state = action.payload
    },

    resetGroupFDData: () => initialState,
  },
})

const { reducer } = groupFDSlice

const {
  updateSuitabilityFormDetails,
  updateQuotationDetails,
  updateNomineeDetails,
  updateQuoteID,
  updateConsentID,
  updateGroupFDData,
  resetGroupFDData,
} = groupFDSlice.actions

export {
  reducer as groupFDReducer,
  updateQuotationDetails,
  updateNomineeDetails,
  updateSuitabilityFormDetails,
  updateQuoteID,
  updateConsentID,
  updateGroupFDData,
  resetGroupFDData,
}
